var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4289C1",
    d: "M27 22H9s-9 0-9 7c0 3.156 4 7 4 7h28s4-3.844 4-7c0-7-9-7-9-7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F9CA55",
    cx: 18,
    cy: 28,
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M9 9.938V21c0 4.971 4.029 9 9 9s9-4.029 9-9V10.25L9 9.938z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M10.847 17.715c0 1.58-.8 2.861-1.788 2.861s-1.788-1.281-1.788-2.861c0-1.58.801-2.861 1.788-2.861s1.788 1.281 1.788 2.861zm17.882 0c0 1.58-.8 2.861-1.788 2.861s-1.788-1.281-1.788-2.861c0-1.58.8-2.861 1.788-2.861s1.788 1.281 1.788 2.861z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M18 4.823c-7.019 0-10.139 4.684-10.139 8.588 0 3.903 1.343 4.986 1.56 3.903.78-3.903 3.12-5.101 3.12-5.101 4.68 3.904 3.9.781 3.9.781 4.679 4.684 2.34 0 2.34 0 1.56 1.562 6.239 1.562 6.239 1.562s.78 1.198 1.559 2.759c.78 1.562 1.56 0 1.56-3.903 0-3.905-3.9-8.589-10.139-8.589z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M17 34l-5-1-2-1H7l-1 4h11c1 0 1-1 1-1 0-.553-1-1-1-1zm9-2l-2 1-5 1s-1 .447-1 1c0 0 0 1 1 1h11l-1-4h-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M22 22c-.553 0-1-.447-1-1v-1c0-.553.447-1 1-1s1 .447 1 1v1c0 .553-.447 1-1 1zm-8 0c-.552 0-1-.447-1-1v-1c0-.553.448-1 1-1s1 .447 1 1v1c0 .553-.448 1-1 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M19 26.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.499 8c-.209 0-.419-.065-.599-.2l-4-3C.458 4.469.369 3.842.7 3.4c.332-.441.958-.531 1.4-.2l4 3c.442.331.531.958.2 1.4-.197.262-.497.4-.801.4zm3.002-3c-.323 0-.64-.156-.833-.445l-2-3c-.306-.46-.182-1.081.277-1.387.459-.307 1.08-.182 1.387.277l2 3c.306.459.182 1.081-.277 1.387-.171.114-.364.168-.554.168zm22 3c-.305 0-.604-.138-.801-.4-.332-.442-.242-1.069.2-1.4l4-3c.44-.333 1.068-.242 1.399.2.332.442.242 1.069-.2 1.4l-4 3c-.179.135-.389.2-.598.2zm-3.002-3c-.19 0-.383-.054-.554-.168-.46-.306-.584-.927-.277-1.387l2-3c.306-.459.925-.585 1.387-.277.46.306.584.927.277 1.387l-2 3c-.192.289-.51.445-.833.445z",
    fill: "#5DADEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowing);
export default __webpack_public_path__ + "static/media/bowing.6e29a467c786207780ac53812be7a528.svg";
export { ForwardRef as ReactComponent };